module.exports = __webpack_public_path__ + "img/bg.dfc68f4.dfc68f40.png";